var _defs, _g, _rect, _rect2, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileReferralIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.069,
    y1: -0.147,
    x2: 0.84,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5498",
    "data-name": "Rectangle 5498",
    width: 13.671,
    height: 14.525,
    fill: "none",
    stroke: "#1c1c1c",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_35581",
    "data-name": "Group 35581",
    transform: "translate(-21 -302)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_35528",
    "data-name": "Group 35528"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5513",
    "data-name": "Rectangle 5513",
    width: 71,
    height: 71,
    rx: 35.5,
    transform: "translate(21 302)",
    fill: "#fc3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5523",
    "data-name": "Rectangle 5523",
    width: 71,
    height: 71,
    rx: 35.5,
    transform: "translate(21 302)",
    fill: "#fc3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_35542",
    "data-name": "Group 35542",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5513-2",
    "data-name": "Rectangle 5513",
    width: 71,
    height: 71,
    rx: 35.5,
    transform: "translate(21 302)",
    fill: "url(#linear-gradient)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5523-2",
    "data-name": "Rectangle 5523",
    width: 71,
    height: 71,
    rx: 35.5,
    transform: "translate(21 302)",
    fill: "url(#linear-gradient)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_35532",
    "data-name": "Group 35532",
    transform: "translate(-3 -15.943)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Area",
    width: 39.943,
    height: 39.943,
    transform: "translate(42 333.5)",
    fill: "#fcfcfc",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M25.8,22.486V19.157A6.656,6.656,0,0,0,19.141,12.5H7.492A6.658,6.658,0,0,0,.833,19.157v3.329",
    transform: "translate(42.831 343.965)",
    fill: "none",
    stroke: "#1c1c1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Path-2",
    "data-name": "Path",
    cx: 6.657,
    cy: 6.657,
    r: 6.657,
    transform: "translate(49.489 338.493)",
    fill: "none",
    stroke: "#1c1c1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39484",
    "data-name": "Path 39484",
    d: "M7.333,7.5l3.418-3.418L7.333.667",
    transform: "translate(69.484 338.076)",
    fill: "none",
    stroke: "#1c1c1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39485",
    "data-name": "Path 39485",
    d: "M.667,12.732a9.4,9.4,0,0,1,9.4-9.4h2.563",
    transform: "translate(67.606 338.827)",
    fill: "none",
    stroke: "#1c1c1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileReferralIcon);
export default __webpack_public_path__ + "static/media/profile-referral-icon.ca8c62fc7b6f1ad8c2108838b06a6dc0.svg";
export { ForwardRef as ReactComponent };